import { jsx as _jsx } from "react/jsx-runtime";
import { isAbsoluteUrlPath } from '@zurich-framework/core/utils';
import Image from 'next/image';
import { useBasePath } from '@zurich/common/hooks';
import { styled } from '@zurich/ui/legacy/utils';
// necessary to support sx props
const ImageStyled = styled(Image)({});
export function NextImage({ src, width, height, fill, ...props }) {
    const { withBasePath } = useBasePath();
    const autoSize = width === undefined && height === undefined;
    return (_jsx(ImageStyled, { ...props, src: typeof src === 'string' && isAbsoluteUrlPath(src)
            ? withBasePath(src)
            : src, width: width, height: height, fill: fill, style: autoSize && !fill
            ? { objectFit: 'contain', width: '100%', height: 'auto' }
            : undefined }));
}
